import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import PasswordRecoveryContainer from './Password-recovery.container';
import PasswordConfirmContainer from '../Password-confirm/Password-confirm.container';
import ConfirmSuccessContainer from '../Confirm-success/Confirm-success.container';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { user } = useStore();

    if (user.passwordConfirmed)
        return (
            <>
                <ConfirmSuccessContainer onClose={onClose} />
            </>
        );
    else {
        if (!user.email)
            return (
                <>
                    <PasswordRecoveryContainer onClose={onClose} />
                </>
            );
        else
            return (
                <>
                    <PasswordConfirmContainer onClose={onClose} />
                </>
            );
    }
};

const PasswordRecoveryWrapContainer = observer(Container);

export default PasswordRecoveryWrapContainer;
